import { render } from "./futuresData.vue?vue&type=template&id=6ec4083d&scoped=true"
import script from "./futuresData.vue?vue&type=script&lang=js"
export * from "./futuresData.vue?vue&type=script&lang=js"

import "./futuresData.vue?vue&type=style&index=0&id=6ec4083d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec4083d"]])

export default __exports__